import { createContext, useContext, useState } from 'react';
import { useUser } from './UserContext';
const SearchSessionContext = createContext(null);
// eslint-disable-next-line react-refresh/only-export-components
export const useSearchSession = () => useContext(SearchSessionContext);
function Session({ children }) {
  const [snapshot, setSnapshot] = useState(null);
  const [discoverySnapshot, setDiscoverySnapshot] = useState(null);
  return <SearchSessionContext.Provider value={{ snapshot, setSnapshot, discoverySnapshot, setDiscoverySnapshot }}>{children}</SearchSessionContext.Provider>;
}
export function SearchSessionProvider({ children }) {
  const { user } = useUser();
  return <Session key={user?.id || 'guest'}>{children}</Session>;
}
